/**
 * @file
 * Provide methods for scrolling to anchor-links
 *
 * The selector searches for all links which value of the href-attribute begins
 * with a '#'.
 */

(function ($, Drupal) {
  Drupal.behaviors.localscroll = {
    attach: function attach(context) {
      $("a[href^='#']").click(function(event) {
        if ($(this).attr('href') != '#' && !$(this).parents('.js-tabs .tabs').length) {
          event.preventDefault();
          const aid = $(this).attr("href");
          $("html, body").stop(true, false).animate({
            scrollTop: $(aid).offset().top
          }, 600);
        }
      });
    }
  };
})(jQuery, Drupal);
